import { useRef, useEffect } from 'react';

const useUnload = (fn: any) => {
  const cb = useRef(fn); // init with fn, so that type checkers won't assume that current might be undefined

  // @ts-ignore
  const callbackFunction = (...args) => cb.current?.(...args);

  const onUnload = useRef(callbackFunction);

  useEffect(() => {
    cb.current = fn;
    onUnload.current = callbackFunction;
  }, [fn]);

  const removeListener = () => {
    if (typeof window === 'object') {
      window?.removeEventListener('beforeunload', onUnload.current);
    }
  };

  useEffect(() => {
    if (typeof window === 'object') {
      window.addEventListener('beforeunload', onUnload.current);
    }

    return () => removeListener();
  }, []);

  return { removeUnloadListener: removeListener };
};

export default useUnload;